import { cartConfig } from '../../../../../config';
import { http } from '../../../../../api/axios';
import { ShoppingCartMetaOut } from '../../../../../store/api';

export const fetchCartCheckoutMeta = () => {
    return http.get<ShoppingCartMetaOut>(cartConfig().endpointMeta).then(res => res.data);
};
